import {ApiService} from './api.service';

/**
 * DirectoryService
 */
export const DirectoryService = {
    rootPath: 'directories',

    add(payload) {
        return ApiService.post(this.rootPath + '/', payload);
    },

    addTags(payload) {
        return ApiService.post(this.rootPath + '/' + payload.directorySlug + '/tags', {
            tags: payload.tags
        });
    },

    delete(directorySlug) {
        return ApiService.delete(this.rootPath + '/' + directorySlug);
    },

    fetch(directorySlug = null) {
        let uri = this.rootPath + (directorySlug ? ('/' + directorySlug) : '');
        return ApiService.get(uri);
    },

    rename(directorySlug, newName) {
        return ApiService.put(this.rootPath + '/' + directorySlug + '/rename', {
            'name': newName
        });
    }
};